import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction, CollapseTransition } from '@cloud-sn/v-utils';
import { ICON_OPEN, ICON_CLOSE } from './utils';
import SubMixin from './mixins/sub';
export default {
  name: 'InnerNode',
  mixins: [SubMixin],
  props: {
    prefixCls: {
      type: String,
      default: ''
    },
    node: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isNotAllowDrop: false
    };
  },
  computed: {
    isLeaf: function isLeaf() {
      var isTreeLazy = this.isTreeLazy,
          _this$node = this.node,
          isLeaf = _this$node.isLeaf,
          isParent = _this$node.isParent,
          isLoaded = _this$node.isLoaded,
          children = _this$node.children;
      return isLeaf || !isParent && !isTreeLazy || isTreeLazy && isLoaded && (!children || children.length === 0);
    },
    isSelectable: function isSelectable() {
      var isTreeSelectable = this.isTreeSelectable,
          selectable = this.node.selectable;

      if (selectable === false) {
        return false;
      }

      return !!selectable || !!isTreeSelectable;
    },
    isDisabled: function isDisabled() {
      var isTreeDisabled = this.isTreeDisabled,
          isDisabled = this.node.isDisabled;

      if (isDisabled === false) {
        return false;
      }

      return !!isDisabled || !!isTreeDisabled;
    },
    isExpanded: function isExpanded() {
      return this.node.isExpanded;
    },
    isAllowDrag: function isAllowDrag() {
      var allowDrag = this.allowDrag,
          node = this.node;
      return !(isFunction(allowDrag) && allowDrag(node.originNode, node) === false);
    },
    isAllowDrop: function isAllowDrop() {
      var allowDrop = this.allowDrop,
          node = this.node;
      return !(isFunction(allowDrop) && allowDrop(node.originNode, node) === false);
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          _this$node2 = this.node,
          isParent = _this$node2.isParent,
          isChecked = _this$node2.isChecked,
          isNodeDisabled = _this$node2.isDisabled,
          isSelected = _this$node2.isSelected,
          isHalfChecked = _this$node2.isHalfChecked,
          isLoading = _this$node2.isLoading,
          dragOverGap = _this$node2.dragOverGap,
          isDisabled = this.isDisabled,
          isExpanded = this.isExpanded,
          isAllowDrag = this.isAllowDrag,
          isAllowDrop = this.isAllowDrop;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-treenode-disabled"), isDisabled), _defineProperty(_ref, "".concat(prefixCls, "-treenode-switcher-").concat(isExpanded ? 'open' : 'close'), isParent), _defineProperty(_ref, "".concat(prefixCls, "-treenode-checkbox-checked"), !!isChecked), _defineProperty(_ref, "".concat(prefixCls, "-treenode-checkbox-indeterminate"), !isNodeDisabled && isHalfChecked), _defineProperty(_ref, "".concat(prefixCls, "-treenode-selected"), isSelected), _defineProperty(_ref, "".concat(prefixCls, "-treenode-loading"), isLoading), _defineProperty(_ref, 'drag-over', !isDisabled && dragOverGap === 'mid'), _defineProperty(_ref, 'drag-over-gap-top', !isDisabled && dragOverGap === 'top'), _defineProperty(_ref, 'drag-over-gap-bottom', !isDisabled && dragOverGap === 'bottom'), _defineProperty(_ref, 'not-allow-drop', !isDisabled && !isAllowDrop), _defineProperty(_ref, 'not-allow-drag', !isDisabled && !isAllowDrag), _ref;
    },
    checkboxClasses: function checkboxClasses() {
      var _ref2;

      var prefixCls = this.prefixCls,
          isDisabled = this.isDisabled,
          _this$node3 = this.node,
          disableCheckbox = _this$node3.disableCheckbox,
          isNodeDisabled = _this$node3.isDisabled,
          isChecked = _this$node3.isChecked,
          isHalfChecked = _this$node3.isHalfChecked;
      return _ref2 = {}, _defineProperty(_ref2, "".concat(prefixCls, "-checkbox"), true), _defineProperty(_ref2, "".concat(prefixCls, "-checkbox-checked"), isChecked), _defineProperty(_ref2, "".concat(prefixCls, "-checkbox-indeterminate"), !isNodeDisabled && !isChecked && isHalfChecked), _defineProperty(_ref2, "".concat(prefixCls, "-checkbox-disabled"), isDisabled || disableCheckbox), _ref2;
    },
    nodeState: function nodeState() {
      var isExpanded = this.isExpanded,
          isParent = this.node.isParent;
      var nodeState = '';

      if (isParent) {
        nodeState = isExpanded ? ICON_OPEN : ICON_CLOSE;
      }

      return nodeState;
    },
    selectorClasses: function selectorClasses() {
      var _ref3;

      var prefixCls = this.prefixCls,
          isDisabled = this.isDisabled,
          nodeState = this.nodeState,
          draggable = this.draggable,
          isSelected = this.node.isSelected;
      var wrapCls = "".concat(prefixCls, "-node-content-wrapper");
      return _ref3 = {}, _defineProperty(_ref3, wrapCls, true), _defineProperty(_ref3, "".concat(wrapCls, "-").concat(nodeState || 'normal'), true), _defineProperty(_ref3, "".concat(prefixCls, "-node-selected"), !isDisabled && isSelected), _defineProperty(_ref3, "draggable", !isDisabled && draggable), _ref3;
    },
    innerSwitcher: function innerSwitcher() {
      return this.renderSwitcher();
    },
    innerCheckbox: function innerCheckbox() {
      return this.renderCheckbox();
    },
    innerSelector: function innerSelector() {
      return this.renderSelector();
    },
    innerChildren: function innerChildren() {
      return this.renderChildren();
    }
  },
  methods: {
    onSelect: function onSelect(e) {
      var node = this.node,
          onNodeSelect = this.onNodeSelect;
      node.isSelected = !node.isSelected;
      onNodeSelect(e, node, this);
    },
    onCheck: function onCheck(e) {
      var node = this.node,
          isDisabled = this.isDisabled,
          onNodeCheck = this.onNodeCheck;

      if (isDisabled || node.disableCheckbox) {
        return;
      }

      node.isChecked = !node.isChecked;
      node.isHalfChecked = false;
      onNodeCheck(e, node, this);
    },
    onSelectorClick: function onSelectorClick(e) {
      var isSelectable = this.isSelectable,
          isDisabled = this.isDisabled,
          node = this.node,
          onSelect = this.onSelect,
          onCheck = this.onCheck,
          onNodeClick = this.onNodeClick;
      e.preventDefault();

      if (isDisabled) {
        return;
      }

      if (isSelectable) {
        onSelect(e);
      } else {
        onCheck(e);
      }

      onNodeClick(e, node, this);
    },
    onExpand: function onExpand(e) {
      var isExpanded = this.isExpanded,
          node = this.node,
          onNodeExpand = this.onNodeExpand;
      e.preventDefault();
      node.isExpanded = !isExpanded;
      onNodeExpand(e, node, this);
    },
    onDragStart: function onDragStart(e) {
      e.stopPropagation();
      var isAllowDrag = this.isAllowDrag,
          node = this.node,
          onNodeDragStart = this.onNodeDragStart;

      if (!isAllowDrag) {
        e.preventDefault();
        return;
      }

      onNodeDragStart(e, node, this);

      try {
        // firefox drag
        e.dataTransfer.setData('text/plain', '');
      } catch (err) {// empty
      }
    },
    onDrag: function onDrag(e) {
      e.stopPropagation();
    },
    onDragEnter: function onDragEnter(e) {
      var node = this.node,
          onNodeDragEnter = this.onNodeDragEnter;
      e.preventDefault();
      e.stopPropagation();
      onNodeDragEnter(e, node, this);
    },
    onDragOver: function onDragOver(e) {
      var node = this.node,
          onNodeDragOver = this.onNodeDragOver;
      e.preventDefault();
      e.stopPropagation();
      onNodeDragOver(e, node, this);
    },
    onDragEnd: function onDragEnd(e) {
      var node = this.node,
          onNodeDragEnd = this.onNodeDragEnd;
      e.stopPropagation();
      onNodeDragEnd(e, node, this);
    },
    onDragLeave: function onDragLeave(e) {
      var node = this.node,
          onNodeDragLeave = this.onNodeDragLeave;
      e.stopPropagation();
      onNodeDragLeave(e, node, this);
    },
    onDrop: function onDrop(e) {
      var isAllowDrop = this.isAllowDrop,
          node = this.node,
          onNodeDrop = this.onNodeDrop;
      e.stopPropagation();

      if (!isAllowDrop && node.dragOverGap === 'mid') {
        e.preventDefault();
        return;
      }

      onNodeDrop(e, node, this);
    },
    renderSwitcher: function renderSwitcher() {
      var _switcherCls;

      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          isExpanded = this.isExpanded,
          isLeaf = this.isLeaf,
          onExpand = this.onExpand;

      if (isLeaf) {
        return h("span", {
          "class": "".concat(prefixCls, "-switcher ").concat(prefixCls, "-switcher-noop")
        });
      }

      var switcherCls = (_switcherCls = {}, _defineProperty(_switcherCls, "".concat(prefixCls, "-switcher"), true), _defineProperty(_switcherCls, "".concat(prefixCls, "-switcher_").concat(isExpanded ? ICON_OPEN : ICON_CLOSE), true), _switcherCls);
      return h("span", {
        "class": switcherCls,
        "on": {
          "click": onExpand
        }
      });
    },
    renderCheckbox: function renderCheckbox() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          isTreeCheckable = this.isTreeCheckable,
          checkboxClasses = this.checkboxClasses,
          onCheck = this.onCheck;

      if (!isTreeCheckable) {
        return null;
      }

      return h("span", {
        "class": checkboxClasses,
        "on": {
          "click": onCheck
        }
      }, [h("span", {
        "class": "".concat(prefixCls, "-checkbox-inner")
      })]);
    },
    renderSelector: function renderSelector() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          draggable = this.draggable,
          selectorClasses = this.selectorClasses,
          node = this.node,
          isDisabled = this.isDisabled,
          isSelectable = this.isSelectable,
          isLeaf = this.isLeaf,
          isExpanded = this.isExpanded,
          onSelectorClick = this.onSelectorClick,
          treeRenderContentFn = this.treeRenderContentFn,
          onDragStart = this.onDragStart,
          onDragEnd = this.onDragEnd;
      var title = node.title,
          isLoading = node.isLoading;
      var titleElement = h("span", {
        "class": "".concat(prefixCls, "-title")
      }, [title]);
      var attrs = {
        title: title
      };

      if (!isDisabled && draggable) {
        attrs.draggable = true;
      }

      var on = {
        click: onSelectorClick,
        dragstart: onDragStart,
        // drag: onDrag,
        dragend: onDragEnd
      };
      var selectorElement = h("span", _mergeJSXProps([{}, {
        class: selectorClasses,
        attrs: attrs,
        on: on,
        ref: 'selectorRef'
      }]), [isFunction(treeRenderContentFn) ? treeRenderContentFn({
        node: _objectSpread({}, node, {
          isDisabled: isDisabled,
          isSelectable: isSelectable,
          isLeaf: isLeaf,
          isExpanded: isExpanded
        })
      }) : titleElement]);
      return isLoading ? [h("i", {
        "class": "".concat(prefixCls, "-icon_loading")
      }), selectorElement] : selectorElement;
    },
    renderChildren: function renderChildren() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          isExpanded = this.isExpanded,
          children = this.node.children; // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/235

      if (!children || children.length === 0 || children.every(function (_ref4) {
        var isVisible = _ref4.isVisible;
        return !isVisible;
      })) {
        return null;
      }

      var nodes = null;

      if (isExpanded) {
        var _childTreeCls;

        var childTreeCls = (_childTreeCls = {}, _defineProperty(_childTreeCls, "".concat(prefixCls, "-child-tree"), true), _defineProperty(_childTreeCls, "".concat(prefixCls, "-child-tree-open"), isExpanded), _childTreeCls);
        nodes = h("ul", {
          "class": childTreeCls,
          "attrs": {
            "data-expanded": isExpanded
          }
        }, [children.map(function (childNode) {
          return h("inner-node", {
            "props": _objectSpread({}, {
              prefixCls: prefixCls,
              node: childNode
            })
          });
        })]);
      }

      return h(CollapseTransition, [nodes]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        isVisible = this.node.isVisible,
        innerSwitcher = this.innerSwitcher,
        innerCheckbox = this.innerCheckbox,
        innerSelector = this.innerSelector,
        innerChildren = this.innerChildren,
        onDragEnter = this.onDragEnter,
        onDragOver = this.onDragOver,
        onDragLeave = this.onDragLeave,
        onDrop = this.onDrop;
    var on = {
      dragenter: onDragEnter,
      dragleave: onDragLeave,
      dragover: onDragOver,
      drop: onDrop
    };
    /**
     *  http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/235
     *  原来逻辑是使用v-show控制节点显示隐藏，show-line模式下可能导致last-child选择器无效
     */

    return isVisible ? h("li", _mergeJSXProps2([{}, {
      class: classes,
      attrs: {
        tabindex: 0
      },
      on: on
    }]), [[innerSwitcher, innerCheckbox, innerSelector, innerChildren]]) : null;
  }
};